import styled from "styled-components";

import media from "../../../helpers/media";

const StyledLogoList = styled.ul`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    max-width: 20em;

    ${media.xs`
        justify-content: center;
        max-width: 50em;
    `}

`

export default StyledLogoList;


// WEBPACK FOOTER //
// ./src/styles/styledComponents/blocks/styledLogoList.js